import { render } from "./TileBlock.vue?vue&type=template&id=6dd058a6&ts=true"
import script from "./TileBlock?vue&type=script&lang=ts"
export * from "./TileBlock?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__